import TSBeitragDTO from './TSBeitragDTO';

export default class TSBeitraegeSearchresultDTO {

    private _schadenfallBeitragDTOs: Array<TSBeitragDTO> = [];
    private _totalResultSize: number = 0;

    public get schadenfallBeitragDTOs(): Array<TSBeitragDTO> {
        return this._schadenfallBeitragDTOs;
    }

    public set schadenfallBeitragDTOs(value: Array<TSBeitragDTO>) {
        this._schadenfallBeitragDTOs = value;
    }

    get totalResultSize(): number {
        return this._totalResultSize;
    }

    set totalResultSize(value: number) {
        this._totalResultSize = value;
    }

    public parseBeitragDTOs(data: any): TSBeitragDTO[] {
        let schadenfallBeitragDTO: TSBeitragDTO[] = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                schadenfallBeitragDTO[i] = new TSBeitragDTO().deserialize(data[i]);
            }
        } else {
            schadenfallBeitragDTO[0] = new TSBeitragDTO().deserialize(data);
        }
        return schadenfallBeitragDTO;
    }

    deserialize(restObject: any): TSBeitraegeSearchresultDTO {

        this.schadenfallBeitragDTOs = this.parseBeitragDTOs(restObject.schadenfallBeitragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSBeitraegeSearchresultDTO.ts